(() => {
  const configuredGroup = document.currentScript?.dataset.vlJumpGroup?.trim().toLowerCase();
  const PARAMETER_NAME = 'vl-jump';
  const PARAMETER_VALUE = 'lightweight';
  const CHANGE_EVENT = 'vl-abtest:change';
  const MAX_TARGET_ATTEMPTS = 100;
  const TARGET_RETRY_DELAY = 50;
  const TARGET_SELECTORS = {
    a: [
      '#shopify-section-template--24881940463988__image_slider_111',
      '[id$="__image_slider_111"]',
    ],
    b: [
      '#shopify-section-template--28812848038260__vl_pdp_04_color_showcase',
      '[id$="__vl_pdp_04_color_showcase"]',
    ],
  };

  const requestedJump = new URL(window.location.href).searchParams.get(PARAMETER_NAME)?.trim().toLowerCase();
  if (requestedJump !== PARAMETER_VALUE) return;

  let attemptId = 0;
  let lastJumpedGroup = null;

  const getActiveGroup = () => {
    if (configuredGroup === 'a' || configuredGroup === 'b') return configuredGroup;
    if (configuredGroup !== 'auto') return null;

    const apiGroup = window.VLAbTest?.getGroup?.();
    const rootGroup = document.documentElement.getAttribute('data-vl-abtest-group');
    const group = String(apiGroup || rootGroup || '').trim().toLowerCase();

    return Object.hasOwn(TARGET_SELECTORS, group) ? group : null;
  };

  const findTarget = (group) => {
    const selectors = TARGET_SELECTORS[group] || [];

    for (const selector of selectors) {
      const target = document.querySelector(selector);
      if (target && !target.closest('vl-ab-group[hidden]')) return target;
    }

    return null;
  };

  const getStickyBottom = () => {
    const candidates = document.querySelectorAll('.shopify-section-header, .vl-pdp-sticky-anchor-nav-section');
    let stickyBottom = 0;

    candidates.forEach((element) => {
      const styles = window.getComputedStyle(element);
      if (styles.display === 'none' || styles.visibility === 'hidden') return;
      if (styles.position !== 'fixed' && styles.position !== 'sticky') return;

      const rect = element.getBoundingClientRect();
      if (rect.bottom <= 0 || rect.top >= window.innerHeight) return;
      if (rect.top > stickyBottom + 2) return;

      stickyBottom = Math.max(stickyBottom, rect.bottom);
    });

    return stickyBottom;
  };

  const alignTarget = (target) => {
    if (!target?.isConnected) return;

    const desiredTop = getStickyBottom() + 16;
    const difference = target.getBoundingClientRect().top - desiredTop;

    if (Math.abs(difference) > 1) {
      window.scrollBy({ top: difference, behavior: 'auto' });
    }
  };

  const scrollToTarget = (target) => {
    target.scrollIntoView({ behavior: 'auto', block: 'start' });

    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(() => alignTarget(target));
    });
    window.setTimeout(() => alignTarget(target), 180);
  };

  const attemptJump = () => {
    const group = getActiveGroup();
    if (!group || group === lastJumpedGroup) return;

    const currentAttemptId = ++attemptId;
    let attemptCount = 0;

    const tryTarget = () => {
      if (currentAttemptId !== attemptId) return;

      const currentGroup = getActiveGroup();
      if (currentGroup !== group) {
        attemptJump();
        return;
      }

      const target = findTarget(group);
      if (target) {
        lastJumpedGroup = group;
        scrollToTarget(target);
        return;
      }

      attemptCount += 1;
      if (attemptCount < MAX_TARGET_ATTEMPTS) {
        window.setTimeout(tryTarget, TARGET_RETRY_DELAY);
      }
    };

    tryTarget();
  };

  document.addEventListener(CHANGE_EVENT, attemptJump);
  window.addEventListener('pageshow', attemptJump);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attemptJump, { once: true });
  }

  attemptJump();
})();
